<template>
  <div class="page-block">
    <div
      class="form--error error-message">
      <div class="error-text error--text">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SignUpVerify',
  data() {
    return {
      message: '',
    }
  },
  mounted() {
    this.$store.commit('hideSidebar')
    this.checkVerifyToken()
  },
  destroyed() {
    this.$store.commit('showSidebar')
  },
  methods: {
    async checkVerifyToken() {
      try {
        const { data } = await window.axios.post('/api/client/registration/verify', {
          token: this.$route.params.token,
        })
        if (data.error) {
          this.message = data.message
        } else {
          await this.$store.dispatch(
            'auth/tokenLogin',
            { token: data.access_token },
          )
          if (data.member_number) {
            window.sessionStorage.setItem('RegisteredMemberName', data.member_number)
          }
          if (this.$route.query.invitation_code) {
            const type = this.$route.query?.type ?? 'revenue-share'
            if (type === 'copyright') {
              window.location.href = `/client/signup-success?invitation_code=${this.$route.query.invitation_code}&rsId=${this.$route.query.rsId}&type=${type}`
            } else {
              window.location.href = `/client/signup-success?invitation_code=${this.$route.query.invitation_code}&rsId=${this.$route.query.rsId}&productId=${this.$route.query.productId}&type=${type}`
            }
          } else {
            window.location.href = `/client/signup-success${data.redirect_query}`
          }
        }
      } catch (response) {
        const { message } = response.data
        if (response.status === 422) {
          this.message = message
        }
        window.scrollTo(0, 0)
      }
    },
  },
}
</script>

<style scoped>
.error-message {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
}
</style>
